import { PivotBoard } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/PivotBoard';
import { RowsBoard } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/RowsBoard/RowsBoard';
import { ActivitiesPredecessors } from 'components/widgets/ActivityCompletionPlan/ActivitiesPredecessors';
import { VersionCompareTrackedActivities } from 'components/widgets/ChangeAnalysisTrackedActivities/versionCompareTrackedActivities';
import { ChangeSummary } from 'components/widgets/ChangeSummary/ChangeSummary';
import { CriticalActivitiesAndDelayDrivers } from 'components/widgets/CriticalActivitiesAndDelayDrivers/RenderCriticalAnalysisDelayDrivers';
import { CriticalPathAdded } from 'components/widgets/CriticalPathAdded/CriticalPathAdded';
import { CriticalPathRemoved } from 'components/widgets/CriticalPathRemoved/CriticalPathRemoved';
import { CurrentSPI } from 'components/widgets/CurrentSPI/CurrentSPI';
import { CustomReportText } from 'components/widgets/CustomReportText/CustomReportText';
import { DelayedActivities } from 'components/widgets/DelayedActivities/DelayedActivities';
import { FinishDateFuturePotentialDelayDrivers } from 'components/widgets/FinishDateFuturePotentialDelayDrivers/components/FinishDateFuturePotentialDelayDrivers';
import { FinishDateOverallSummary } from 'components/widgets/FinishDateOverallSummary/FinishDateOverallSummary';
import { FinishDatePredictionCompletionPlan as finishDatePredictionActivitiesPredecesssors } from 'components/widgets/FinishDatePredictionCompletionPlan/FinishDatePredictionCompletionPlan';
import { GanttChart } from 'components/widgets/Gantt/GanttChart';
import { HighLevelProgram } from 'components/widgets/HighLevelProgram/HighLevelProgram';
import { ImageUploader } from 'components/widgets/ImageUploader/ImageUploader';
import { KeyAchievements } from 'components/widgets/KeyAchievements/keyAchievements';
import { KeyActivities } from 'components/widgets/KeyActivities/KeyActivities';
import { LargestAddedActivities } from 'components/widgets/LargestAddedActivities/LargestAddedActivities';
import { LargestDeletedActivities } from 'components/widgets/LargestDeletedActivities/LargestDeletedActivities';
import { LargestDurationVariance } from 'components/widgets/LargestDurationVariance/LargestDurationVariance';
import { LargestFloatChanges } from 'components/widgets/LargestFloatChanges/LargestFloatChanges';
import { LogicQualityCategoriesTable } from 'components/widgets/LogicQualityCategoriesTable/LogicQualityCategoriesTable';
import { LogicQualitySingleCheck } from 'components/widgets/LogicQualitySingleCheck/LogicQualitySingleCheck';
import { LogicQualitySingleCheckWrapper } from 'components/widgets/LogicQualitySingleCheck/LogicQualitySingleCheckWrapper';
import { MilestonesDistribution } from 'components/widgets/MilestonesDistribution/MilestonesDistribution';
import { OverallStatus } from 'components/widgets/OverallStatus/OverallStatus';
import { PhasePerformanceBreakdown } from 'components/widgets/PhasePerformanceBreakdown/PhasePerformanceBreakdown';
import { PhasePerformanceChart } from 'components/widgets/PhasePerformanceChart/PhasePerformanceChart';
import { PrioritiesMatrix } from 'components/widgets/PrioritiesMatrix/prioritiesMatrix';
import { ProductivityRiskKPI } from 'components/widgets/ProductivityRiskKPI/ProductivityRiskKPI';
import { ProductivityRiskTrend } from 'components/widgets/ProductivityRiskTrend/ProductivityRiskTrend';
import { ProgressSummary } from 'components/widgets/ProgressSummary/ProgressSummary';
import { ProjectScorecards } from 'components/widgets/ProjectScorecards/ProjectScorecards';
import { ProjectSummary } from 'components/widgets/ProjectSummary/ProjectSummary';
import { RecommendationsTable } from 'components/widgets/Recommendations/recommendationsTable';
import { RelationshipCountChanges } from 'components/widgets/RelationshipCountChanges/RelationshipCountChanges';
import { ResourcesAnalysisChart } from 'components/widgets/ResourcesAnalysisChart/ResourcesAnalysisChart';
import { RiskDensity } from 'components/widgets/RiskDensity/RiskDensity';
import { RiskRegister } from 'components/widgets/RiskRegister/RiskRegister';
import { ProductivityTable } from 'components/widgets/RunRateActivitiesDrilldown/productivityTable';
import { ProductivityRate } from 'components/widgets/RunRateChart/productivityRate';
import { CriticalityWeightedSCurve } from 'components/widgets/SCurve/Scurve';
import { ScheduleDelay } from 'components/widgets/ScheduleDelay/ScheduleDelay';
import { ScheduleQualityScore } from 'components/widgets/ScheduleQualityScore/ScheduleQualityScore';
import { ScheduleQualityTrend } from 'components/widgets/ScheduleQualityTrend/ScheduleQualityTrend';
import { ChangedActivitiesTable } from 'components/widgets/ScheduleSimulation/components/ChangedActivitiesTable/ChangedActivitiesTable';
import { SharedResourcesAvailability } from 'components/widgets/SharedResourcesAvailability/sharedResourcesAvailability';
import { SingleStory } from 'components/widgets/SingleStory/singleStory';
import { SpiTrend } from 'components/widgets/SpiTrend/SpiTrend';
import { SummaryTrackedActivitiesComponent } from 'components/widgets/SummaryTrackedActivities/summaryTrackedActivitiesComponent';
import { RenderTopDurationOverrunRisk } from 'components/widgets/TopDurationOverrunRisk/topDurationOverrunRisk';
import { TopFinishDateChanges } from 'components/widgets/TopFinishDateChanges/TopFinishDateChanges';
import { RelationshipTypeChanges } from 'components/widgets/TopRelationshipTypeChanges/RelationshipTypeChanges';
import { StartDateChanges } from 'components/widgets/TopStartDateChanges/startDateChanges';
import { StatusChanges } from 'components/widgets/TopStatusChanges/statusChanges';
import { Trends } from 'components/widgets/Trends/Trends';
import { AutomatedNarrative } from 'components/widgets/automatedNarrative/AutomatedNarrative';
import { ReportSummary } from 'components/widgets/reportSummary/ReportSummary';
import { ResourcesAnalysisTable } from 'components/widgets/resourcesAnalysisTable/resourcesAnalysisTable';
import { TimelineAndDensity } from 'components/widgets/timelineAndDensity/timelineAndDensity';

export const widgetComponents = {
    riskHeatMap: {
        Component: RiskDensity,
    },
    criticalityWeightedSCurve: {
        Component: CriticalityWeightedSCurve,
    },
    topCriticalActivitiesDelayDrivers: {
        Component: CriticalActivitiesAndDelayDrivers,
    },
    topDurationOverrunRisk: {
        Component: RenderTopDurationOverrunRisk,
    },
    progressSummary: {
        Component: ProgressSummary,
    },
    topOverdueOverrunActivities: {
        Component: DelayedActivities,
    },
    highLevelProgramLatest: {
        Component: HighLevelProgram,
    },
    milestonesWeightedSCurve: {
        Component: MilestonesDistribution,
    },
    mySummaryTrackedActivities: {
        Component: SummaryTrackedActivitiesComponent,
    },
    myVersionCompareTrackedActivities: {
        Component: VersionCompareTrackedActivities,
    },
    topStatusChanges: {
        Component: StatusChanges,
    },
    topStartDateChanges: {
        Component: StartDateChanges,
    },
    topFinishDateChanges: {
        Component: TopFinishDateChanges,
    },
    largestDurationVariance: {
        Component: LargestDurationVariance,
    },
    largestFloatChanges: {
        Component: LargestFloatChanges,
    },
    topRelationshipsTypeChanges: {
        Component: RelationshipTypeChanges,
    },
    topRelationshipsCountChanges: {
        Component: RelationshipCountChanges,
    },
    largestAddedActivities: {
        Component: LargestAddedActivities,
    },
    largestDeletedActivities: {
        Component: LargestDeletedActivities,
    },
    criticalPathAdded: {
        Component: CriticalPathAdded,
    },
    criticalPathRemoved: {
        Component: CriticalPathRemoved,
    },
    topRecommendations: {
        Component: RecommendationsTable,
    },
    changeSummary: {
        Component: ChangeSummary,
    },
    projectSummary: {
        Component: ProjectSummary,
    },
    spiTrend: {
        Component: SpiTrend,
    },
    productivityRiskTrend: {
        Component: ProductivityRiskTrend,
    },
    scheduleQualityTrend: {
        Component: ScheduleQualityTrend,
    },
    prioritiesMatrix: {
        Component: PrioritiesMatrix,
    },
    keyAchievements: {
        Component: KeyAchievements,
    },
    projectScorecards: {
        Component: ProjectScorecards,
    },
    overallStatus: {
        Component: OverallStatus,
    },
    dataStories: {
        Component: SingleStory,
    },
    battlecardsRowsBoard: {
        Component: RowsBoard,
    },
    phasePerformanceChart: {
        Component: PhasePerformanceChart,
    },
    phasePerformanceBreakdown: {
        Component: PhasePerformanceBreakdown,
    },
    activityPredecessors: {
        Component: ActivitiesPredecessors,
    },
    ganttChart: {
        Component: GanttChart,
    },
    sharedResourcesAvailability: {
        Component: SharedResourcesAvailability,
    },
    keyActivities: {
        Component: KeyActivities,
    },
    timelineAndDensity: {
        Component: TimelineAndDensity,
    },
    finishDateOverallSummary: {
        Component: FinishDateOverallSummary,
    },
    finishDateActivitiesPredecessors: {
        Component: finishDatePredictionActivitiesPredecesssors,
    },
    finishDateFuturePotentialDelayDrivers: {
        Component: FinishDateFuturePotentialDelayDrivers,
    },
    changedActivities: {
        Component: ChangedActivitiesTable,
    },
    resourcesAnalysisTable: {
        Component: ResourcesAnalysisTable,
    },
    productivityTable: {
        Component: ProductivityTable,
    },
    productivityRate: {
        Component: ProductivityRate,
    },
    resourcesAnalysisChart: {
        Component: ResourcesAnalysisChart,
    },
    trends: {
        Component: Trends,
    },
    riskRegister: {
        Component: RiskRegister,
    },
    customReportText: {
        Component: CustomReportText,
    },
    scheduleQualityScore: {
        Component: ScheduleQualityScore,
    },
    currentSpi: {
        Component: CurrentSPI,
    },
    scheduleDelay: {
        Component: ScheduleDelay,
    },
    productivityRiskKpi: {
        Component: ProductivityRiskKPI,
    },
    automatedNarrative: {
        Component: AutomatedNarrative,
    },
    outOfSequence: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Out Of Sequence' }),
    },
    danglingLogic: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Dangling Logic' }),
    },
    leads: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Leads' }),
    },
    lags: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Lags' }),
    },
    relationshipTypes: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Relationship Types' }),
    },
    hardConstraints: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Hard Constraints' }),
    },
    highFloatByActivityType: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'High Float by Activity Type' }),
    },
    negativeFloatByActivityType: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Negative Float by Activity Type',
        }),
    },
    constraintsWithoutRelationship: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Constraints Without Relationship',
        }),
    },
    longDuration: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Long Duration' }),
    },
    invalidActualDates: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Invalid Actual Dates' }),
    },
    invalidForecastDates: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Invalid Forecast Dates' }),
    },
    unresourcedActivities: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Unresourced Activities' }),
    },
    missedActivities: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Missed Activities' }),
    },
    criticalPathTest: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Critical Path Test' }),
    },
    criticalPathLengthIndex: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Critical Path Length Index' }),
    },
    baselineExecutionIndex: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Baseline Execution Index' }),
    },
    missingBaselineDates: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Missing Baseline Dates' }),
    },
    duplicateRelations: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Duplicate Relations' }),
    },
    softConstraints: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, { check: 'Soft Constraints' }),
    },
    allScheduleQualityChecks: {
        Component: LogicQualityCategoriesTable,
    },
    sensitiveActivitiesByDuration: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Sensitive Activities by Duration',
        }),
    },
    relationshipsActivitiesRatio: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Relationships/Activities Ratio',
        }),
    },
    frequentlyUsedResources: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Frequently Used Resources',
        }),
    },
    rarelyUsedResources: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Rarely Used Resources',
        }),
    },
    workSettingsApplied: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Work Settings Applied',
        }),
    },
    incompleteWithFinishDate: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Incomplete With Finish Date',
        }),
    },
    startFinishTimeNotRound: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Start/Finish Time Not Round',
        }),
    },
    activitiesWithLateStartTime: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Activities With Late Start Time',
        }),
    },
    activitiesWithEarlyFinishTime: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Activities With Early Finish Time',
        }),
    },
    criticalPathCongestion: {
        Component: LogicQualitySingleCheckWrapper(LogicQualitySingleCheck, {
            check: 'Critical Path Congestion',
        }),
    },
    reportSummary: {
        Component: ReportSummary,
    },
    activitiesPivotTableView: {
        Component: PivotBoard,
    },
    image: {
        Component: ImageUploader,
    },
};
